import { Grid } from '@mui/material'
import dayjs from 'dayjs'
import AddTimerIntervalsComponent from '../AddIntervals'
import BellTypeDropDown from '../BellTypeDropDown'
import { GenericTimerSettingsGridContainer } from '../styledComponents'
import { MuiRangeTimerTimeClockInput } from './styledComponents'

export default function RangeTimerSettings({
  timerSettings,
  setTimerSettings,
  handleChange,
  intervals,
  setIntervals,
  intervalDurationLimits,
}) {
  const secondTimerSeconds = timerSettings?.maxDuration / 1000

  const seconds = Math.floor(secondTimerSeconds % 60)
  const minutes = Math.floor((secondTimerSeconds / 60) % 60)

  function changeDuration(timeMomentValue) {
    if (!timeMomentValue.isValid()) {
      setTimerSettings((prev) => ({
        ...prev,
        maxDuration: prev?.maxDuration,
      }))
    }

    const minutes = timeMomentValue.format('mm')
    const seconds = timeMomentValue.format('ss')

    if (isNaN(minutes)) {
      timeMomentValue = timeMomentValue.add(1, 'minute')
    }

    if (isNaN(seconds)) {
      timeMomentValue = timeMomentValue.add(1, 'second')
    }

    console.log({ minutes, seconds })

    setTimerSettings((prev) => ({
      ...prev,
      maxDuration: Number(minutes) * 60 * 1000 + Number(seconds) * 1000,
    }))
  }

  return (
    <GenericTimerSettingsGridContainer spacing={2} container>
      <Grid xs={12} item>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <span>Max Duration</span>
          <MuiRangeTimerTimeClockInput
            label="Format with seconds"
            value={dayjs(
              `2022-04-17T15:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
                2,
                '0',
              )}`,
            )}
            isTimeInvalid={
              isNaN(timerSettings?.maxDuration) ||
              timerSettings?.maxDuration <= timerSettings?.duration
            }
            onChange={changeDuration}
            // defaultValue={dayjs('2022-04-17T15:30')}
            format="mm:ss"
          />
        </div>
      </Grid>
      <BellTypeDropDown bellType={timerSettings?.bellType} handleChange={handleChange} />
      <AddTimerIntervalsComponent
        intervals={intervals}
        setIntervals={setIntervals}
        intervalDurationLimits={intervalDurationLimits}
      />
    </GenericTimerSettingsGridContainer>
  )
}
